import { render, staticRenderFns } from "./AgrupadorEmMassaV2.vue?vue&type=template&id=2e4c944f"
import script from "./AgrupadorEmMassaV2.vue?vue&type=script&lang=js"
export * from "./AgrupadorEmMassaV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports